import React, { useState } from 'react';
import { lazyLoadOffset } from '../../utils';
import LinesForProduct from '../BuildingBlocks/Lines/LinesForProduct';
import LazyLoad from 'react-lazyload';

export default function ProductsLayout({
  linesGroupedByProduct,
  products,
  isLineBeingEdited,
  setLineInfoDuringEdit,
  addOrDeleteError,
  handleLineSubmit,
  lineOnEditMode,
}) {
  const [anchorOpened, setAnchorOpened] = useState(false);

  return (
    <>
      {linesGroupedByProduct?.map((linesForProduct, i) => {
        const product = products?.find(
          (product) => product?.id === linesForProduct[0]?.product,
        );
        linesForProduct = linesForProduct?.filter((line) => !line.empty);
        return (
          <React.Fragment key={i}>
            <LazyLoad
              offset={lazyLoadOffset}
              style={{ marginTop: i === 0 ? '16px' : '' }}
            >
              <LinesForProduct
                lines={linesForProduct}
                product={product}
                isLineBeingEdited={isLineBeingEdited}
                anchorOpened={anchorOpened}
                setAnchorOpened={setAnchorOpened}
                handleEditActiveLineDetails={handleLineSubmit}
                setLineInfoDuringEdit={setLineInfoDuringEdit}
                addOrDeleteError={addOrDeleteError}
                lineOnEditMode={lineOnEditMode}
              />
            </LazyLoad>
          </React.Fragment>
        );
      })}
    </>
  );
}
